import { RouteType } from "../../../types/RouteType";
import CustomerDeliverySchedulingWorkflowStore from "./CustomerDeliverySchedulingWorkflowStore";

const CustomerDeliverySchedulingWorkflowRoute: RouteType = {
  name: "Customer Delivery Scheduling",
  path: "/workflows/customer-delivery-scheduling",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./CustomerDeliverySchedulingWorkflowHeader"),
      title: "Create Order",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./CustomerDeliverySchedulingWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.customerDeliverySchedulingWorkflowStore) {
      rootStore.customerDeliverySchedulingWorkflowStore = new CustomerDeliverySchedulingWorkflowStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.customerDeliverySchedulingWorkflowStore as CustomerDeliverySchedulingWorkflowStore;
    store.reset();
    return true;
  },
};

export default CustomerDeliverySchedulingWorkflowRoute;
